export default __webpack_public_path__ + "static/media/Image1.54e587a9.png";